// src/vuetify.js
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

// Create Vuetify instance with Material theme
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#0b5048',
          secondary: '#1dcfba',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#06baa5',
          warning: '#f2711c',
        },
      },
      /*  dark: {
        colors: {
          primary: '#2196F3',
          secondary: '#616161',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
        },
      }, */
    },
  },
  defaults: {
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VCard: {
      elevation: 2,
    },
  },
});

export default vuetify;